import React ,{useEffect,useState} from 'react';
import { useLocation,useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { ADMIN } from "../config/api";
import toast from "react-hot-toast";

function AddOrder() {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderId = queryParams.get("id"); // <-- null for Add, string for Edit
    const navigate = useNavigate();
  const token = localStorage.getItem("token");

const [formdata, setForm] = useState({ tid:"",cid: "",type:"", total: "" ,status:""});
      const [errors, setErrors] = useState({});
      const [loading, setLoading] = useState(false);
      const [message, setMessage] = useState("");


      
          useEffect(() => {
        if (orderId) {
          const fetchOrder = async () => {
            try {
              const { data } = await apiClient.get(ADMIN.GET_ORDER);
              if (data.success) {
                const order = data.items.find(p => p._id === orderId);
                if (order) {
                  setForm({
                    tid: order.table_id,
                    cid: order.customer_id,
                    type: order.type,
                    total: order.total,
                    status: order.status
                  });
                }
              }
            } catch (err) {
              console.error("Error fetching order:", err);
              toast.error(err.response?.data?.message || err.message || "Failed to fetch order data");
            }
          };
          fetchOrder();
        }
      }, [orderId]);

        
      const validate = () => {
        const e = {};
        if (!formdata.tid )
          e.tid = "Table Id is Requiered";
        if (!formdata.cid)
          e.cid = "Customer Id is Requiered";
        if (!formdata.type) e.person = "type required";
        if (!formdata.total) e.qrcode = "Total required";
        if (!formdata.status) e.status = "Status required";
        setErrors(e);
        return Object.keys(e).length === 0;
      };
    
      const formChangeData = (ev) => {
        const { name, value } = ev.target;
            
            setForm((f) => ({ ...f, [name]: value }));
          
          setMessage("");
      };
    
      const handleSubmit = async (ev) => {
  ev.preventDefault();
  if (!validate()) return;
  setLoading(true);
  setMessage("");


  try {
    const url = orderId ? ADMIN.UPDATE_ORDER(orderId) : ADMIN.ADD_ORDER;
    const method = orderId ? "put" : "post";

    const { data } = await apiClient[method](url, formdata);
    if (!data.success) throw new Error(data?.message || "Operation failed");

    toast.success(data.message || (orderId ? "Order updated successfully" : "Order added successfully"));
    if(!orderId){
      setForm({ tid:"",cid: "",type:"", total: "" ,status:""});
    }
    setTimeout(() => {
      navigate("/order");
    }, 1000);
  } catch (err) {
    toast.error(err.response?.data?.message || err.message || "Operation failed");
  } finally {
    setLoading(false);
  }
};


  return (
    <div>
      <div className="col-12 grid-margin container-scroller" >
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title"></h4>
                    <form method="post" onSubmit={handleSubmit} className="form-sample">
                      <p className="card-description"> Add Order </p>
                      <div className="row">

                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Table Id</label>
                            <div className="col-sm-9">
                              <input type="text" name="tid" value={formdata.tid} onChange={formChangeData} className="form-control" />
                              {errors.tid && <small className="text-danger">{errors.tid}</small>}
                            </div>
                          </div>
                        </div>
                        
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Customer Id</label>
                            <div className="col-sm-9">
                              <input type="text" name="cid" value={formdata.cid} onChange={formChangeData} className="form-control" />
                              {errors.cid && <small className="text-danger">{errors.cid}</small>}
                            </div>
                          </div>
                        </div>
                    </div>

                        <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Type</label>
                            <div className="col-sm-9">
                              <input type="text" name="type" value={formdata.type} onChange={formChangeData} className="form-control" />
                              {errors.type && <small className="text-danger">{errors.type}</small>}
                            </div>
                          </div>
                        </div>
                      
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Total</label>
                            <div className="col-sm-9">
                              <input className="form-control" name="total" value={formdata.total} onChange={formChangeData} />
                              {errors.total && <small className="text-danger">{errors.total}</small>}
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Status</label>
                            <div className="col-sm-9">
                              <select className="form-control" name="status" value={formdata.status} onChange={formChangeData}>
                                <option value="">-- Select Status --</option>
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                              {errors.status && <small className="text-danger">{errors.status}</small>}
                            </div>
                          </div>
                        </div>
                       {/* <div className="col-md-6">
                          <label>Image</label>
                          <input type="file" name="image" onChange={formChangeData} className="form-control" />
                          {errors.image && <small className="text-danger">{errors.image}</small>}
                        </div> */}
                        <div className="row mt-3">
                          <div className="col-md-12 text-center">
                            <button 
                              type="submit" 
                              className="btn btn-primary" 
                              >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default AddOrder